import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/src/locale/ru'

import { Ripple } from 'vuetify/lib/directives'

import { light, dark } from '@/themes'

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

import '@/plugins/vuetify/base.less'

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light,
      dark,
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})
